import { PureComponent, Fragment } from "react";
import ButtonComponent from "/components/core/button/button-component";
import ClusterOptionComponent from "./cluster-option-component/cluster-option-component";
import LayoutOptionComponent from "/components/segments/cluster-selection/layout-option-component/layout-option-component";
import ClusterSolutionsComponent from "/components/segments/cluster-selection/cluster-solutions-component/cluster-solutions-component";

import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import { setCookie } from "/services/cookies-service";

import { CLUSTER_CONFIG_MOBILE, CLUSTER_MOBILE_OPTION_VALUE } from "/services/clusters/clusters-service-mobile";

import { CLUSTER_CONFIG, CLUSTER_OPTION_VALUE } from "/services/clusters/clusters-service";
import {
  CLUSTER_WITH_SOLUTION_OPTION_VALUE,
  CLUSTER_WITH_SOLUTION_CONFIG
} from "/services/clusters/clusters-with-solutions-service";
import { LAYOUT_CONFIG, LAYOUT_OPTION_VALUE } from "services/clusters/layout-service";

import { scrollTo } from "/services/dom-utils-service";

import { componentStyles } from "./cluster-selection-component.scss";

const STEP2_HASH = "#step2";

export default class ClusterSelectionComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.nextStep = this.nextStep.bind(this);
    this.renderOption = this.renderOption.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.onBrowserHashChangeEvent = this.onBrowserHashChangeEvent.bind(this);
    this.renderItemSelectionForm = this.renderItemSelectionForm.bind(this);
    this.renderSecondStep = this.renderSecondStep.bind(this);

    this._nextButton = null;
    this._config = this.getConfigFromSelection(props.selection);

    this.state = {
      selectedId: null,
      firstStepCompleted: false
    };
  }

  getConfigFromSelection(selection) {
    switch (selection) {
      case CLUSTER_OPTION_VALUE:
        return CLUSTER_CONFIG;
      case CLUSTER_WITH_SOLUTION_OPTION_VALUE:
        return CLUSTER_WITH_SOLUTION_CONFIG;
      case LAYOUT_OPTION_VALUE:
        return LAYOUT_CONFIG;
      case CLUSTER_MOBILE_OPTION_VALUE:
        return CLUSTER_CONFIG_MOBILE;
      default:
        return CLUSTER_CONFIG;
    }
  }

  getOptionComponentFromSelection(selection) {
    switch (selection) {
      case CLUSTER_OPTION_VALUE:
      case CLUSTER_WITH_SOLUTION_OPTION_VALUE:
      case CLUSTER_MOBILE_OPTION_VALUE:
        return ClusterOptionComponent;
      case LAYOUT_OPTION_VALUE:
        return LayoutOptionComponent;
      default:
        return ClusterOptionComponent;
    }
  }

  componentDidMount() {
    window.onhashchange = this.onBrowserHashChangeEvent;
  }

  onBrowserHashChangeEvent() {
    const hash = window.location.hash;

    if (hash.length === 0) {
      this.setState({ firstStepCompleted: false });
    }
  }

  getSelectedItem() {
    const { selectedId } = this.state;
    const { options } = this._config;
    return options.filter((option) => option.id === selectedId)[0];
  }

  selectItem(id) {
    const { itemClickedEvent, withoutContinueButton } = this._config;
    BigBrain("track", itemClickedEvent, { kind: id });

    this.setState({ selectedId: id });
    if (withoutContinueButton) {
      this.nextStep(id);
    } else if (this._nextButton) {
      scrollTo(this._nextButton.offsetTop, 600);
    }
  }
  renderOption(option, singleImage) {
    const { selectedId } = this.state;
    const { selection } = this.props;
    const { withoutContinueButton } = this._config;

    const OptionComponent = this.getOptionComponentFromSelection(selection);

    return (
      <OptionComponent
        key={option.id}
        option={option}
        selected={option.id === selectedId}
        selectCallback={this.selectItem}
        singleImage={singleImage}
        showCheckboxIcon={withoutContinueButton}
      />
    );
  }

  nextStep(id) {
    let selectedId;
    if (typeof id === "string") {
      selectedId = id;
    }
    selectedId = selectedId || this.state.selectedId;
    let clusterKind = selectedId;
    const { itemSelectedEvent, selectedItemCookieName } = this._config;
    if (!selectedId) {
      clusterKind = "empty";
      selectedId = "other";
    }

    BigBrain("track", itemSelectedEvent, { kind: clusterKind });
    if (selectedItemCookieName) {
      setCookie(selectedItemCookieName, selectedId);
    }

    if (!window.location.hash) {
      window.location.href = window.location.href + STEP2_HASH;
    }
    this.setState({ firstStepCompleted: true, selectedId });
  }

  renderItemSelectionForm() {
    const { options, withoutContinueButton } = this._config;

    return (
      <Fragment>
        <div className="cluster-selection-options-wrapper">{options.map((option) => this.renderOption(option))}</div>
        {!withoutContinueButton && (
          <div className="button-wrapper" ref={(el) => (this._nextButton = el)}>
            <ButtonComponent className="btn-continue" onClickCallback={this.nextStep} color={"brand-blue"}>
              Continue
            </ButtonComponent>
          </div>
        )}
      </Fragment>
    );
  }

  renderSecondStep() {
    const { secondStepScreen } = this._config;

    if (secondStepScreen === "Solutions") return this.renderSolutionsScreen();
    return this.renderSelectedItemStep();
  }

  renderSolutionsScreen() {
    const { showDecorations } = this.props;
    const selectedItem = this.getSelectedItem();
    let cta = this._config.ctaText || "Create your account";

    return (
      <div className="cluster-solutions-wrapper">
        <ClusterSolutionsComponent showDecorations={showDecorations} selectedCluster={selectedItem} cta={cta} />
      </div>
    );
  }

  renderSelectedItemStep() {
    const { showDecorations } = this.props;
    let cta = this._config.ctaText || "Create your account";

    return (
      <Fragment>
        <div className="selected-cluster-wrapper"> {this.renderOption(this.getSelectedItem(), true)}</div>
        <div className="button-wrapper-signup">
          <SignupFormComponent buttonColor={"brand-blue"} ctaText={cta} showDecorations={showDecorations} />
        </div>
      </Fragment>
    );
  }

  getTitleHtml() {
    const { firstStepCompleted } = this.state;
    const { firstStepHtmlTitle, secondStepHtmlTitle, otherDetailsHtmlTitle } = this._config;

    if (!firstStepCompleted) return firstStepHtmlTitle;
    const selectedItem = this.getSelectedItem();
    if (selectedItem.secondStepHtmlTitle) return selectedItem.secondStepHtmlTitle;
    return selectedItem.isOther ? otherDetailsHtmlTitle : secondStepHtmlTitle;
  }

  getSubtitleHtml() {
    const { subtitleHtml, secondStepSubtitleHtml } = this._config;
    const { firstStepCompleted } = this.state;

    if (firstStepCompleted) return secondStepSubtitleHtml;
    return subtitleHtml;
  }

  render() {
    const { firstStepCompleted } = this.state;

    const titleHtml = this.getTitleHtml();
    const subTitleHtml = this.getSubtitleHtml();

    return (
      <div className="cluster-selection-wrapper">
        <div className="form-wrapper">
          <div className="manage-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />
          {subTitleHtml && <div className="manage-subtitle" dangerouslySetInnerHTML={{ __html: subTitleHtml }} />}
          {firstStepCompleted ? this.renderSecondStep() : this.renderItemSelectionForm()}
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
